export const COMMUNITIES_LOAD_START = 'COMMUNITIES_LOAD_START'
export const COMMUNITIES_LOAD_END = 'COMMUNITIES_LOAD_END'
export const COMMUNITY_CREATE_START = 'COMMUNITY_CREATE_START'
export const COMMUNITY_CREATE_END = 'COMMUNITY_CREATE_END'
export const SELECT_COMMUNITY = 'SELECT_COMMUNITY'
